<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="IM聊天记录">
                <div style="background: #ffffff;position:relative;">
                    <div class="search-condition-con search-condition-first" :class="isShowMore && 'show'">
                        <div class="search-condition">
                            <span class="label">站点</span>
                            <div class="input-condition">
                                <site-auto-complete v-model="siteId"  :clueId=1 :init-choose-first="true" :owned='true' ref="siteAutoComplete" @created="initData" ></site-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition" v-if="siteId">
                            <span class="label">楼盘</span>
                            <div class="input-condition">
                                <house-auto-complete v-model="condition.house_name" :type ="2" :site-id="siteId" clearable></house-auto-complete>
                            </div>
                        </div>
                        <div class="search-condition" v-if="siteId">
                            <span class="label">经纪人</span>
                            <div class="input-condition">
                                <agent-auto-complete
                                    :siteId="siteId"
                                    ref="autoAgent"
                                    v-model="condition.admin_id"
                                    clearable
                                ></agent-auto-complete>
                            </div>
                        </div>    
                        <div class="search-condition">
                            <span class="label">经纪人手机</span>
                            <div class="input-condition">
                                <el-input placeholder="请输入经纪人手机" class="input-control" v-model="condition.admin_mobile"></el-input>
                            </div>
                        </div>


                        <div class="search-condition search-condition-time">
                            <span class="label">时间段</span>
                            <div class="input-condition">
                                <el-date-picker
                                    v-model="condition.time"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="请选择开始日期"
                                    end-placeholder="请选择结束日期"
                                    align="right"
                                    >
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                    <a class="el-icon-d-arrow-left search-arrow-down" :class="!isShowMore && 'hide'" @click.stop="isShowMore = !isShowMore"></a>
                    <div class="btn-condition">
                        <el-button type="primary" @click="handleSearch()">查 询</el-button>
                        <el-button  @click="resetSearch()">清空条件</el-button>
                    </div>
                </div>

                <el-table
                    :data="list"
                    style="width: 100%"
                    :highlight-current-row="true"
                    stripe
                    tooltip-effect="dark"
                    ref="multipleTable"
                    v-loading="isLoading"
                    header-cell-class-name="table-back"
                >
                    <el-table-column  label="站点" prop="city_name" ></el-table-column>
                    <el-table-column  label="客户名称">
                        <template slot-scope="scope">
                            <span v-if="scope.row.customer_nickname">{{scope.row.customer_nickname}}</span>
                            <span v-else>{{scope.row.customer_mobile}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  label="咨询楼盘" prop="house_name"></el-table-column>
                    <el-table-column  label="页面位置" prop="position"></el-table-column>
                    <el-table-column  label="来源终端" prop="terminal" ></el-table-column>
                    <el-table-column label="经纪人名称" width="180">
                        <template slot-scope="scope">
                        <span>{{scope.row.admin_name}}</span><span v-if="scope.row.admin_nickname">({{scope.row.admin_nickname}})</span>
                        </template>
                    </el-table-column>
                    <el-table-column  label="经纪人手机" prop="admin_mobile"></el-table-column>
                    <el-table-column  label="消息数" prop="msg_cnt"></el-table-column>
                    <el-table-column  label="聊天开始时间"  prop="created_at" width="200"></el-table-column>
                   
                    <el-table-column  label="操作" width="290px">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="getDetail(scope.row)" v-permission="'data.im.detail'">查看聊天记录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
                <detail ref="detail"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    import { parseTime } from '@/utils'
    import { getImList} from '@/service/customer'
    import SiteAutoComplete from "../../../../components/auto-complete/site-auto-complete";
    import HouseAutoComplete from "../../../../components/auto-complete/house-auto-complete";
    import AgentAutoComplete from "../../../../components/auto-complete/agent-auto-compelete";
    import detail from "./component/detail";

export default {
    name: 'DataPhoneList',
    components: {SiteAutoComplete ,HouseAutoComplete ,AgentAutoComplete,detail},

    data () {
        return {
            list: [
            ],
            loading:false,
            isShowMore: false,
            isLoading: false,
            condition: {
                page :1,
                per_page : 10,
                broker_id:null,
                admin_mobile :null,
                house_name:null,
                admin_id:null,
                time: [],
                total:0,
            },
            siteId:null,
            chatDetail:null,
        }
    },

    methods: {
        resetSearch(){
            this.condition = {
                page :1,
                per_page : 10,
                total : 0,
                broker_id:null,
                admin_mobile : '',
                house_name:'',
                time : []
            }
            this.siteId=null;
             this.$nextTick(() => {
                this.$refs.siteAutoComplete && this.$refs.siteAutoComplete.reset();
            })
            //this.initData()
        },
        handleSearch() {
            this.condition.page = 1
            this.initData()
        },
        async initData () {
            this.list = []
            // 初始化之前设置当前页面的loading状态
            this.isLoading = true
            let query = Object.assign({}, this.condition)
            query.time = null
            if (this.condition.time.length > 0) {
                query.start_time = new Date(this.condition.time[0]).getTime()/1000
                query.end_time = new Date(this.condition.time[1]).getTime()/1000
            }
            query.site_id=this.siteId
            await getImList(query).then((data) => {
                this.condition.total= parseInt(data.data.total)
                this.condition.per_page = parseInt(data.data.per_page)
                let listData = data.data.data
                this.list = listData
            })
            // 数据请求完毕取消当前页面的loading
            this.isLoading = false
        },
        currentChange (index) {
            this.condition.page = index
            this.initData()
        },
        getDetail(row){
            this.$refs.detail
                &&  (this.$refs.detail.info = row)
                && this.$refs.detail.open()
        },
    }
}
</script>
<style scoped lang="less">

</style>
